import moment from 'moment';

/**
 * Formats a date as relative time (e.g., "4 DAYS AGO", "2 HOURS AGO")
 */
export const formatRelativeTime = (date: Date): string => {
  return moment(date).fromNow().toUpperCase();
};

